import React from "react";
import {
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
} from "@mui/material";

export type OrgOption = { id: string; name: string };

type Props = {
  showArchived: boolean;
  onShowArchivedChange: (show: boolean) => void;
  organizationId: string | null;
  onOrganizationIdChange: (id: string | null) => void;
  organizationOptions: OrgOption[];
};

const PropertiesToolbar: React.FC<Props> = ({
  showArchived,
  onShowArchivedChange,
  organizationId,
  onOrganizationIdChange,
  organizationOptions,
}) => (
  <Grid container spacing={2} alignItems="center" sx={{ px: 2, pb: 2, pt: 0.5 }}>
    <Grid size={{ xs: 12, sm: "auto" }}>
      <FormControlLabel
        control={(
          <Switch
            checked={showArchived}
            onChange={(_, checked) => onShowArchivedChange(checked)}
            color="primary"
          />
        )}
        label="Show archived"
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 4, md: 3 }}>
      <FormControl fullWidth size="small" variant="outlined">
        <InputLabel id="admin-properties-org-filter-label">Organization</InputLabel>
        <Select<string>
          labelId="admin-properties-org-filter-label"
          label="Organization"
          value={organizationId ?? ""}
          onChange={(e) => {
            const { value } = e.target;
            onOrganizationIdChange(value === "" ? null : value);
          }}
        >
          <MenuItem value="">
            <em>All organizations</em>
          </MenuItem>
          {organizationOptions.map((org) => (
            <MenuItem key={org.id} value={org.id}>
              {org.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  </Grid>
);

export default PropertiesToolbar;
